import Rory from './rory.png'

export default function Home() {
  return (
    <img src={Rory} alt='rory'/>
  )
}